import { Injectable } from "@angular/core";
import { Observable, Subject } from 'rxjs';

declare var webkitSpeechRecognition: any;

@Injectable({
    providedIn: 'root'
})

export class VoiceRecognitionService {
    recognition = new webkitSpeechRecognition();
    isStoppedSpeechRecog = false;
    public voiceText = '';
    tempWords: any;

    public voiceText$: Observable<string>;
    private textSubject = new Subject<string>();


    constructor() {
        this.voiceText$ = this.textSubject.asObservable();
    }

    init() {
        this.recognition.interimResults = true;
        this.recognition.lang = 'en-US';

        this.recognition.addEventListener('result', (event: any) => {
            const transcript = Array.from(event.results)
                .map((result) => result[0])
                .map((result) => result.transcript)
                .join('');
            this.tempWords = transcript;
            console.log(transcript);
        });
    }

    startSpeach() {
        this.isStoppedSpeechRecog = false;
        this.recognition.start();
        console.log("Speech recognition started");
        this.recognition.addEventListener('end', (condition) => {
            if (this.isStoppedSpeechRecog) {
                this.recognition.stop();
                console.log("End Speech Recognition");
            } else {
                this.wordConcat();
                this.recognition.start();
            }
        });
    }

    stopSpeach() {
        this.isStoppedSpeechRecog = true;
        this.wordConcat()
        this.recognition.stop();
        console.log('End speech recognition');
    }

    getTimeStamp(){
        let now = new Date();
        let hours = now.getHours();
        let minutes = now.getMinutes();
        let seconds = now.getSeconds();
        return `${hours}:${minutes}:${seconds}`;
    }

    wordConcat() {
        let timeStamp = this.getTimeStamp();
        this.voiceText = this.voiceText ? `${this.voiceText}<br /><br />[${timeStamp}]<br />${this.tempWords}` : this.tempWords;
        this.tempWords = '';
    }
}